import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { HttpService } from "src/app/core/data/service/http.service";

// Custom
import { Dictionary } from 'src/app/shared/helpers/util';


export class IntroSlide {
  introSlideId: number;
  appKey: string;
  pageKey: string;
  htmlContent: string;
  elementId: string;
  className: string;
  position: string;
  deleted: boolean;
  sortOrder: number;

  public constructor(entity?: Partial<IntroSlide>) {
    Object.assign(this, entity);
  }
}

export enum TutorialStatus {
  exited = 'exited',
  started = 'started',
  complete = 'complete'
}


@Injectable({
  providedIn: 'root'
})
export class IntroJsService extends HttpService {

  private tutorialDic: Dictionary<IntroSlide[]>;
  private tutorial = 'bb-tutorial';

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = `${this.apiURL}/introslides`;

  }

  async fetchTutorials(pageKey: string) {
    try {
      // refresh if dictionary hasn't been created or key isn't found
      if (this.tutorialDic == null || this.tutorialDic[pageKey] == null) {
        const response = (await super.fetch(`${this.endpoint}/`) as IntroSlide[]).map(m => new IntroSlide(m));
        this.tutorialDic = {};
        response.forEach(t => {
          if (!this.tutorialDic[t.pageKey]) this.tutorialDic[t.pageKey] = [];
          this.tutorialDic[t.pageKey].push(t);
        });
      }
      return this.tutorialDic[pageKey];
    } catch (error) {
      console.error('Error fetching help text. Error: ', error);
      throw error;
    }
  }

  setTutorialStatus(pageKey: string, status: TutorialStatus) {
    const shownTutorials = JSON.parse(localStorage.getItem(this.tutorial) || '{}') as Dictionary<TutorialStatus>;
    shownTutorials[pageKey] = status;
    localStorage.setItem(this.tutorial, JSON.stringify(shownTutorials));
    console.log('Shown Tutorials', JSON.parse(localStorage.getItem(this.tutorial) || '{}') as Dictionary<TutorialStatus>);
  }

  getTutorialStatus(pageKey) {
    const shownTutorials = JSON.parse(localStorage.getItem(this.tutorial) || '{}') as Dictionary<TutorialStatus>;
    return shownTutorials[pageKey];
  }

  resetTutorials() {
    localStorage.setItem(this.tutorial, '{}');
    console.log('Shown Tutorials', JSON.parse(localStorage.getItem(this.tutorial) || '{}') as Dictionary<TutorialStatus>);
  }

  async saveSortOrder(introslides: any[]) {
    // Build the sort order object we are posting
    const sortOrder: any[] = [];
    for (let i = 0; i < introslides.length; i++) {
      sortOrder.push({ id: introslides[i].introSlideId, sortOrder: i });
    }

    try {
      await this.post(sortOrder, `${this.endpoint}/sort`, 'text');
      return true;
    } catch (error) {
      // Something went wrong, log and throw
      console.error('Error setting sort order for intro slides. Error: ', error);
      throw error;
    }
  }

  protected isUpdate(entity: any) {
    return (entity.introSlideId != null);
  }

  protected getUpdateUrl(entity: any) {
    return `${this.endpoint}/${entity.introSlideId}`;
  }

}
